export * from './CertRosetteAltIcon';
export * from './CertRosetteAltIcon16Light';
export * from './CertRosetteAltIcon16Regular';
export * from './CertRosetteAltIcon16Solid';
export * from './CertRosetteAltIcon20Light';
export * from './CertRosetteAltIcon20Regular';
export * from './CertRosetteAltIcon20Solid';
export * from './CertRosetteAltIcon24Regular';
export * from './CertRosetteAltIcon24Solid';
export * from './CertRosetteAltIcon32Regular';
export * from './CertRosetteAltIcon64Regular';
